module.exports = __webpack_public_path__ + "static/media/print.26bbab1c.svg";